import { audioSlice } from './slice';

export default {
  ...audioSlice.actions,
};
